export enum ClubStatus {
    CREATION = 'CREATION',
    CREATED = 'CREATED',
    OPERATIVE = 'OPERATIVE',
    DISABLED = 'DISABLED',
    DELETED = 'DELETED'
  }